<script setup lang="ts">
import { Button } from '@toruslabs/vue-components/Button';
import { MOCAVERSE_DISCORD_URL, MOCAVERSE_TWITTER_URL } from '../../utils/enums';
import IconDiscordYellow from '../../assets/claim/icon-discord-yellow.svg';
import IconTwitterYellow from '../../assets/claim/icon-twitter-yellow.svg';
import MocaIconError from '../../assets/claim/moca-icon-error.svg';
import { useClaimStore } from '../../store/claimStore';

const claimStore = useClaimStore();
</script>

<template>
    <div class="flex flex-col items-center justify-center gap-6">
        <p class="text-moca-error-red text-2xl font-bold">Claim Quota Is Full</p>
        <img :src="MocaIconError" class="w-16 h-16" />
        <p class="text-moca-white-80 text-base font-semibold text-center">
            Claiming Moca ID Quota is full.<br />Follow us for more details
        </p>
        <div class="flex items-center justify-center gap-4">
            <a :href="MOCAVERSE_DISCORD_URL" target="_blank">
                <img :src="IconDiscordYellow" class="w-7 h-7" />
            </a>
            <a :href="MOCAVERSE_TWITTER_URL" target="_blank">
                <img :src="IconTwitterYellow" class="w-7 h-7" />
            </a>
        </div>
        <Button
            class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !w-48 !rounded-full !px-6"
            @on-click="() => claimStore.showClaimMethods()">
            Back
        </Button>
    </div>
</template>
